
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import RecordItem from './RecordItem/index.vue'
import html2canvas from 'html2canvas'
import { Observer } from 'mobx-vue'
import { type BaseCardResult } from '@xt/client/types/record-card'
import moment from 'moment'
import LazyImg from '@/components/lazyImg/index.vue'

export type sharedModalData = {
  courseName: string
  userName: string
  userId: string
  learnTime: string
  watchHour: string
  submitCount: number
  studyProcess: number
  bmrcCount: number
  txhdCount: number
  zjxbName: string
  zjxbId: number
  recordList: BaseCardResult[]
}

@Observer
@Component({
  components: {
    RecordItem,
    LazyImg
  }
})
export default class SummarySharedModal extends Vue {
  @Prop({ default: false, required: true }) visible: boolean
  @Prop() data: sharedModalData

  @Ref()
  imgDom: HTMLDivElement

  loading: boolean = false
  imgSrc: string = ''
  filename: string = '学习小结'

  @Emit('closed')
  onClosed() {}

  get Day() {
    return this.data.learnTime ? moment(this.data.learnTime).format('DD') : 0
  }

  get Month() {
    return this.data.learnTime ? moment(this.data.learnTime).format('M') : 0
  }

  get Year() {
    return this.data.learnTime ? moment(this.data.learnTime).format('YYYY') : 0
  }

  get HeaderImgUrl() {
    return this.getHeaderImgUrl(this.data.userId)
  }

  get HeaderImgUrl02() {
    return this.getHeaderImgUrl(this.SummaryStore.isCommentCountMoreFive ? this.data.zjxbId : '')
  }

  getHeaderImgUrl(id: string | number) {
    const idStr = id.toString()
    const url = new URL(this.$store.$global.fileTarget + this.stringToHex(idStr) + '.jpg')

    if (this.$store.$global.upUpdateTime && this.$store.$storeUser.isLogin() && idStr == this.$store.$storeUser.UserInfo.id) {
      url.searchParams.set('avatar', `${this.$store.$global.upUpdateTime}`)
    }

    url.searchParams.set('t', `${Date.now()}`)

    return url.toString()
  }

  onSave() {
    let a = document.createElement('a') // 生成一个a元素
    let event = new MouseEvent('click') // 创建一个单击事件
    a.download = this.filename + '.jpeg' // 设置图片名称
    a.href = this.imgSrc // 将生成的URL设置为a.href属性
    a.dispatchEvent(event) // 触发a的单击事件
  }

  getImgUrl(shareContent, opts) {
    return new Promise((resolve, reject) => {
      html2canvas(shareContent, opts)
        .then(canvas => {
          let context = canvas.getContext('2d')
          // 【重要】关闭抗锯齿
          // context.mozImageSmoothingEnabled = false;
          // context.webkitImageSmoothingEnabled = false;
          // context.msImageSmoothingEnabled = false;
          context!.imageSmoothingEnabled = false

          // 【重要】默认转化的格式为png,也可设置为其他格式
          const url = canvas.toDataURL('image/jpeg')
          console.log('生成图片成功')
          resolve(url)
        })
        .catch(error => {
          console.log('生成图片失败')
          console.error('html2canvas something went wrong!', error)
          reject(error)
        })
    })
  }

  handleSharedPic() {
    if (this.loading) return

    this.loading = true

    // 获取dom，确认dom存在然后生成，生成过程中给一个加载效果
    this.$nextTick(async () => {
      let shareContent = this.imgDom //需要截图的包裹的（原生的）DOM 对象

      if (!shareContent) return

      let width = shareContent.offsetWidth //获取dom 宽度
      let height = shareContent.offsetHeight //获取dom 高度
      let scale = window.devicePixelRatio || 1 //定义任意放大倍数 支持小数

      const canvas = document.createElement('canvas') //创建一个canvas节点
      canvas.width = width * scale //定义canvas 宽度 * 缩放
      canvas.height = height * scale //定义canvas高度 *缩放
      canvas.style.width = width + 'px'
      canvas.style.height = height + 'px'

      console.log('handleSharedPic,width,height', window.devicePixelRatio, width, height)

      let opts = {
        scale, // 添加的scale 参数
        canvas: canvas, // 自定义 canvas
        logging: true, // 日志开关，便于查看html2canvas的内部执行流程
        width: width, // dom 原始宽度
        height: height,
        useCORS: true, //【重要】开启跨域配置
        backgroundColor: null
      }

      try {
        const res = (await this.getImgUrl(shareContent, opts)) as string
        this.imgSrc = res
        this.onSave()
      } catch (error) {
        this.$message.error('生成图片失败')
      } finally {
        this.loading = false
      }

      // 执行下载操作
    })
  }

  getQrcodeImg() {
    if (!this.UserStore.UserInfo.id) return

    this.SummaryStore.getAppletsQrcode(this.UserStore.UserInfo.id)
  }

  get UserStore() {
    return this.$store.$storeUser
  }

  get SummaryStore() {
    return this.$store.$courseV2.Summary
  }

  @Watch('visible', { immediate: true })
  updateVisible(val) {
    if (!val) return

    // 获取小程序分享二维码
    this.getQrcodeImg()
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
